<template>
  <div id="app">
    <transition name="fade">
      <router-view></router-view>
    </transition>
    <BackTop></BackTop>
  </div>
</template>

<script>
import uuidv1 from 'uuid/v1'
export default {
  name: 'App',
  components: {
  },
  beforeMount() {
    var token = this.$cookies.get("token");
    if (token === null || token === undefined){
      var uuidv = uuidv1();
      console.log(uuidv)
      this.$cookies.set("token", uuidv1());
      this.$axios.post("/home/addView");
      this.$axios.post("/home/visitAddress", {type : "00"});
    }
  }
}
</script>

<style>

#app {
  font-family: "Times New Roman", Times, serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.home-div {
  font-family: "Times New Roman", Times, serif;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
}

body {
  height: 100vh;
  width: 100%;
  background-color: #fff;
  background-image: url("./assets/bak.jpg");
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: 50%;
  overflow: hidden;
}
.top-text {
  color: darkorange;
  display: inline-block;
  line-height: 50px;
  font-size: 20px;
  font-family: "Comic Sans MS", cursive, sans-serif;
}
</style>
